import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md bg-zinc-900/50 border-zinc-800">
        <CardContent className="py-12 text-center">
          <div className="w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="text-yellow-500" size={40} />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">Paiement Annulé</h2>
          <p className="text-zinc-400 mb-8">
            Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
          </p>
          <div className="flex justify-center gap-4">
            <Button onClick={() => navigate('/tarifs-lavage')} className="bg-red-600 hover:bg-red-700">
              Voir les tarifs lavage
            </Button>
            <Button variant="outline" className="border-zinc-700" onClick={() => navigate('/')}>
              Accueil
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
